import styled from 'styled-components'
import { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { Layout, PrimaryButton } from '../components'
// firebase
import { db, FirebaseTimestamp } from '../firebase'
// mui
import Button from '@material-ui/core/Button'
import Rating from '@material-ui/lab/Rating'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { getUserId } from '../reducks/users/selectors'


const ReviewEdit = () => {

    const dispatch = useDispatch()
    const selector = useSelector(state=>state)
    const userId = getUserId(selector)

    // URLからID取得
    let productId = window.location.pathname.split('/product/reviewedit')[1];
    if (productId) { 
      productId = productId?.split('/')[1] 
    }
    let reviewId = ''

    // 入力内容初期化
    const [rating, setRating] = useState(3)
    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    const [isPurchased, setIsPurchased] = useState(false)
    
    // 保存処理
    const saveReview = useCallback((reviewId, rating, title, text) => {
      return async (dispatch) => {

          // Validation
          if (title === '' || text === '' ) {
              alert('未入力の必須項目があります')
              return false
          }

          const timestamp = FirebaseTimestamp.now()
          const reviewRef = db.collection('products').doc(productId).collection('review')
          
          // Firebaseに保存するデータセットを作成
          const data = {
              rating,title,text,
              created_at: timestamp,
              updated_at: timestamp
          }
          // 新規docのidを取得
          const ref = reviewRef.doc()
          reviewId = ref.id
          data.id = reviewId
  
          // Firestoreに保存
          return reviewRef.doc(reviewId).set(data, {merge: true})
              .then(() => {
                  dispatch(push('/product/dp/' + productId))
              }).catch( error => {
                  throw new Error(error)
              })
      }
    },[productId])


    // 商品を購入済みかどうか判定
    useEffect(() => {
      const orders = []
      let orderedProducts = []
      if(userId) {
        db.collection('users').doc(userId)
          .collection('orders').get()
          .then(snapshots => {
            snapshots.forEach(snapshot => {
              orders.push(snapshot.data())
            })
          })
          .then(() => {
            orders.forEach(order => {
              orderedProducts.push(order.products.filter(product => {
                return product.id === productId
              }))
            })
            orderedProducts = [].concat(...orderedProducts)
            setIsPurchased(orderedProducts.length > 0)
          })
      }
    }, [userId, isPurchased, productId])

    useEffect( () => {
      if(productId) {
        const reviewRef = db.collection('products').doc(productId).collection('review')
        if (reviewId !== '') {
          reviewRef.doc(reviewId).get()
                   .then(snapshot => {
                      const data = snapshot.data()
                      setRating(data.rating)
                      setTitle(data.title)
                      setText(data.text)
                   })
        }
      }
    }, [productId,reviewId]);

    return (
      <Layout>

        <ReviewFormWrapper>
          <div className='spacer-100' />
          <h3>レビューを投稿する</h3>
          <div className='spacer-50' />
          {isPurchased ? (
            <>
              <Typography component="legend">５段階評価</Typography>
              <Rating
                name={'5段階評価'}
                value={rating} style={{marginBottom: '10px'}}
                onChange={(event, newValue) => {
                  setRating(newValue);
                }}
              />
              <TextField 
                  fullWidth={true} label={'レビュータイトル'} multiline={false} rows={1} required={true} type={'text'} 
                  value={title} onChange={e=>setTitle(e.target.value)} variant='filled' style={{marginBottom: '10px'}}
              />
              <TextField 
                  fullWidth={true} label={'レビュー本文'} multiline={true} rows={5} required={true} type={'text'} 
                  value={text} onChange={e=>setText(e.target.value)} variant='filled'
              />
              <div className='spacer-50' />
              <ButtonWrapper>
                <PrimaryButton label={'レビューを投稿する'} operation={ () => dispatch(saveReview(reviewId, rating, title, text)) } />
                <div className='spacer-25' />
                <Button onClick={()=>dispatch(push('/product/dp/' + productId))}>商品ページに戻る</Button>
              </ButtonWrapper>
            </>
          ) : (
            <>
              <p style={{textAlign:'center'}}>レビューは商品を購入された方のみ投稿できます</p>
              <div className='spacer-50' />
              <ButtonWrapper>
                <Button onClick={()=>dispatch(push('/product/dp/' + productId))}>商品ページに戻る</Button>
              </ButtonWrapper>
            </>
          )}
          <div className='spacer-100' />
        </ReviewFormWrapper>
      </Layout>
    )
}

export default ReviewEdit

const ReviewFormWrapper = styled.div`
  width: 480px;
  margin: 0 auto;
  @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`
const ButtonWrapper = styled.div`
  text-align: center;
`